import { Button } from '@/components';
import { DateTime } from '@/types/common';
import { Element, Icon, Row } from '@vuddy/components';
import { formatMonthDate } from '@vuddy/utils';
import * as styles from './plannedCTA.css';

interface PlannedCTAProps {
  openDate: DateTime;
}

export const PlannedCTA = ({ openDate }: PlannedCTAProps) => {
  return (
    <Row justifyContent="center" position="relative" width="100%">
      <Button size="large" fullWidth disabled>
        오픈 예정
      </Button>
      <Row gap="gap_small" className={styles.startAtWrapper}>
        <Icon name="OUTLINE_TIMER" size="20px" />
        <Element typography="bodyXs" suppressHydrationWarning>
          오픈 {formatMonthDate(openDate)}
        </Element>
      </Row>
    </Row>
  );
};
